/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { BaseFinalCommand } from "namirasoft-node-cli";
import { IStorageMemoryDedicated } from "namirasoft-core";
import { NamirasoftAccessServer } from "../NamirasoftAccessServer";
import { TokenManager } from "namirasoft-account";

export class PermissionCategoryGetCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, ["id"], []);
    }
    override async exec()
    {
        let token = this.app.storage.getNSAToken();
        if (token == null)
            throw new Error("Token is not available. Please login first using:\nns-access account config \nor \nns-access account login.");
        let storage = new IStorageMemoryDedicated();
        let manager = new TokenManager(storage, () => { });
        manager.setValue(token, false);
        let url = this.app.storage.getItem("ns-access-server-url");
        let server = new NamirasoftAccessServer(url, manager, e => this.app.logger.error(e.message));
        let ans = await server.permission_category.Get(this.arg_values[0]);
        this.app.logger.success(JSON.stringify(ans));
    }
};